(function () {
  'use strict';

  if (window.__skPersistentSaveFailureModalInstalled) return;
  window.__skPersistentSaveFailureModalInstalled = true;

  var FIRST_PAID_BOX_CODE = 'first_paid_box_paid_changes_locked';

  function ensureModal() {
    var existing = document.getElementById('sw-save-failure-modal');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.id = 'sw-save-failure-modal';
    overlay.setAttribute('role', 'alertdialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'sw-save-failure-title');
    overlay.setAttribute('aria-describedby', 'sw-save-failure-copy');
    overlay.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'z-index:10020',
      'background:rgba(0,0,0,.62)',
      'padding:24px',
      'align-items:center',
      'justify-content:center'
    ].join(';');

    overlay.innerHTML = ''
      + '<div style="width:min(520px,100%);background:#fff;border-radius:22px;padding:28px 26px;box-shadow:0 24px 80px rgba(0,0,0,.35);text-align:center;font-family:DM Sans,Arial,sans-serif;">'
      +   '<div style="width:52px;height:52px;margin:0 auto 16px;border-radius:50%;background:#fff1e8;color:#b85c2a;display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:800;">!</div>'
      +   '<h2 id="sw-save-failure-title" style="margin:0 0 10px;font-family:Playfair Display,Georgia,serif;font-size:28px;line-height:1.15;color:#1c1c1c;">We couldn\'t update your weekly selections</h2>'
      +   '<p id="sw-save-failure-copy" style="margin:0 auto 12px;max-width:430px;font-size:16px;line-height:1.55;color:#4a4a4a;">Your update was not finalized. Please review your selections and try again.</p>'
      +   '<p style="margin:0 auto 22px;max-width:430px;font-size:15px;line-height:1.5;color:#6b6b6b;">If this keeps happening, contact SmoKeto so we can make sure your upcoming box and charges are correct.</p>'
      +   '<button type="button" id="sw-save-failure-close" style="width:100%;border:0;border-radius:999px;background:#b85c2a;color:#fff;padding:14px 20px;font:700 16px DM Sans,Arial,sans-serif;cursor:pointer;">Close and review selections</button>'
      + '</div>';

    document.body.appendChild(overlay);
    var close = document.getElementById('sw-save-failure-close');
    if (close) close.addEventListener('click', hideModal);
    return overlay;
  }

  function copyForError(data) {
    var code = data && data.code || '';
    if (code === 'operation_requires_review') {
      return 'We could not safely confirm a previous update attempt. Please contact SmoKeto before trying again so we can verify your upcoming box and charges.';
    }
    if (code === 'cutoff_passed') {
      return 'The selection cutoff for this delivery cycle has passed, so these changes were not finalized.';
    }
    if (code === 'appstle_write_timeout' || code === 'appstle_add_on_verification_failed' || code === 'appstle_contract_verification_failed') {
      return 'We could not safely confirm the subscription update, so your weekly selections were not finalized. Please review your selections and try again.';
    }
    return 'Your update was not finalized. Please review your selections and try again.';
  }

  function showModal(data) {
    if (data && data.code === FIRST_PAID_BOX_CODE) return;
    var modal = ensureModal();
    var copy = document.getElementById('sw-save-failure-copy');
    if (copy) copy.textContent = copyForError(data);
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      var close = document.getElementById('sw-save-failure-close');
      if (close) close.focus();
    }, 0);
  }

  function hideModal() {
    var modal = document.getElementById('sw-save-failure-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function installFetchObserver() {
    if (typeof window.fetch !== 'function' || window.fetch.__skPersistentFailureObserver) return;
    var nativeFetch = window.fetch.bind(window);
    var wrappedFetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var isWeeklySave = /weekly-selection/.test(url) || /phase2-qa-weekly-selection/.test(url);
      return nativeFetch(input, init).then(function (response) {
        if (!isWeeklySave || !response || response.ok) return response;
        response.clone().json().catch(function () { return null; }).then(function (data) {
          showModal(data);
        });
        return response;
      });
    };
    wrappedFetch.__skPersistentFailureObserver = true;
    window.fetch = wrappedFetch;
  }

  function init() {
    ensureModal();
    installFetchObserver();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
